import { Box } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../common/styles';
import { LanguageContext } from '../context/LanguageContextProvider';
import { MessageInfoContext } from '../context/MessageInfoContextProvider';

const NoOperation = () => {
  const { info } = useContext(MessageInfoContext);
  const { language } = useContext(LanguageContext);

  const WIDTH = 280;
  const HEIGHT = 100;

  return (
    <>
      {info.noOperation && (
        <Box
          w={WIDTH}
          h={HEIGHT}
          top={`calc(12%)`}
          left={`calc(50% - ${WIDTH / 2}px)`}
          position='fixed'
          color='white'
          bgColor='black'
          fontSize={language === 'en' ? '15px' : '14px'}
          fontWeight='bold'
          border='solid 3px #FFC000'
          borderRadius='20px'
          padding='5px 10px'
          sx={{ ...commonStyle.center }}
          wordBreak='break-word'
          whiteSpace='pre-wrap'
        >
          {language === 'en' ? info.message_en : info.message}
        </Box>
      )}
    </>
  );
};

export default React.memo(NoOperation);
